<template>
  <div>
    <ul class="nav-bar">
      <li v-for="item in source.sortList" class="nav-tab" :class="item.value.indexOf(source.sortBy)>=0?'active':''" :key="item.label" @click="navClick(item)">
        <span>{{item.label}}</span>
        <em v-if="item.value.length>1" class="nav-icon" :class="item.value.indexOf(source.sortBy)>=0&&source.sortBy.indexOf('desc')>0  ? 'icon-sort icon-desc' : source.sortBy == 'prasc' ? 'icon-sort icon-asc' : 'icon-sort'"></em>
      </li>
      <!-- <li class="nav-tab" :class="activeId == 1 ? 'active' : ''" @click="navClick(1, 'vcdesc')">综合</li>
      <li class="nav-tab" :class="activeId == 2 ? 'active' : ''" @click="navClick(2, 'scdesc')">销量</li>
      <li class="nav-tab" :class="activeId == 3 ? 'active' : ''" @click="navClick(3, '')">
        价格<em class="nav-icon" :class="source.sortBy == 'prdesc' ? 'icon-sort icon-desc' : source.sortBy == 'prasc' ? 'icon-sort icon-asc' : 'icon-sort'"></em>
      </li> -->
      <li class="nav-tab" :class="source.direction=='horizontal' ? 'icon-grid' : 'icon-list'" @click="changeStyle"></li>
      <li class="nav-tab" :style="{'color': source.searchInfo ? '#2F7BFF' : '#1E1F22'}" @click="showFilter">筛选</li>
    </ul>
    <div @click="clickZunxiang" :class="clickZx?'act-filter check':'act-filter'" v-if="filterButtondata.isShow">
        <em :class="clickZx?'check':''"></em>点击筛选
        <img v-if="filterButtondata.type == 1" :src="zunxiangData.mobielZXImgUrl" />
        <img v-if="filterButtondata.type == 2" :src="zunxiangData.pcVipImgUrl" />
        <img v-if="filterButtondata.type == 3" :src="zunxiangData.pcHippoSelectImgUrl" />活动商品
        <span v-if="clickZx">取消</span>
    </div>
  </div>
</template>
<script>
let vm = null;
export default {
  props: ["source","filterButtondata","zunxiangData"],
  data() {
    return {
        clickZx:false
    };
  },
  created() {
    vm = this;
    if ($HMD$.Cookie("navDataIsList") == "no") {
      vm.isList = false;
    }
  },
  methods: {
    navClick(item) {
      vm.$emit("click-event", {
        type: "sort",
        value:
          item.value[1] && this.source.sortBy == item.value[0]
            ? item.value[1]
            : item.value[0],
      });
    },
    changeStyle() {
      vm.$emit("click-event", {
        type: "direction",
        value: vm.source.direction == "horizontal" ? "vertical" : "horizontal",
      });
    },
    showFilter() {
      vm.$emit("click-event", { type: "search", value: true });
    },
    clickZunxiang(){
        this.clickZx = !this.clickZx
        this.clickZx && vm.$emit("click-event", { type: this.filterButtondata.type == 1 || 2 || 3 ? 'sanguan' : null , value: this.filterButtondata });
        !this.clickZx &&  vm.$emit("click-event", { type: this.filterButtondata.type == 1 || 2 || 3 ? 'sanguan' : null, value: null });
        // this.clickZx && vm.$emit("click-event", { type: "zunxiang", value: this.zunxiangData });
        // !this.clickZx &&  vm.$emit("click-event", { type: "zunxiang", value: null });
    }
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/style/theme.less";
.nav-bar {
  background: #fff;
  display: flex;
  height: 4rem;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  .nav-tab {
    flex: 1;
    text-align: center;
    line-height: 4rem;
    position: relative;
    color: #1e1f22;
    font-size: 1.4rem;
    transition: transform 0.5s;
  }
  .active {
    color: @hmd-primary-color;
  }
  .active:after {
    content: " ";
    height: 0.2rem;
    width: 1.6rem;
    background-color: @hmd-primary-color;
    position: absolute;
    bottom: 0.8rem;
    left: 50%;
    margin-left: -0.8rem;
  }
  .nav-icon {
    position: relative;
  }
  .icon-sort:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    top: 0.2rem;
    border-left: 0.3rem solid transparent;
    border-right: 0.3rem solid transparent;
    border-bottom: 0.5rem solid #c4c4c4;
    left: 0.3rem;
  }

  .icon-sort:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    bottom: 0;
    border-left: 0.3rem solid transparent;
    border-right: 0.3rem solid transparent;
    border-top: 0.5rem solid #c4c4c4;
    left: 0.3rem;
  }
  .icon-sort.icon-desc:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    bottom: 0;
    border-left: 0.3rem solid transparent;
    border-right: 0.3rem solid transparent;
    border-top: 0.5rem solid @hmd-primary-color;
    left: 0.3rem;
  }
  .icon-sort.icon-asc:before {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    top: 0.2rem;
    border-left: 0.3rem solid transparent;
    border-right: 0.3rem solid transparent;
    border-bottom: 0.5rem solid @hmd-primary-color;
    left: 0.3rem;
  }
  .icon-grid {
    background: url(../../../assets/images/search-ic-grid.png) no-repeat;
    background-size: 2.4rem;
    background-position: center;
  }

  .icon-list {
    background: url(../../../assets/images/search-ic-list.png) no-repeat;
    background-size: 2.4rem;
    background-position: center;
  }
}
.act-filter{
    width: 80%;
    height: 3rem;
    line-height: 3rem;
    border: 1px solid #F4333C;
    border-radius: 2rem;
    margin: 1rem auto;
    text-align: center;
    position: relative;
    background: #fff;
    &.check{
        background: #FFEFEF;
    }
   
    em{
        width: 1.6rem;
        height: 1.6rem;
        display: inline-block;
        background: url(//image01.homedo.com/Files/Images/cms/www/20230718/5473870649594542494_pic1.png) no-repeat;
        background-size: 100% 100%;
        margin-right: .6rem;
        vertical-align: -4px;
        &.check{
            background: url(//image01.homedo.com/Files/Images/cms/www/20230718/5306027760262409543_pic1.png) no-repeat;
        background-size: 100% 100%; 
        }
    }
    img{
        width: 4.9rem;
        margin: 0 .7rem;
    }
    span{
        position: absolute;
        right: 1rem;
    }
}
</style>